import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// Register service worker for PWA support
serviceWorkerRegistration.register({
    onSuccess: () => {
        console.log('App ready to work offline!');
    },
    onUpdate: (registration) => {
        console.log('New version available! Reload to update.');
        // Optionally show a notification to the user
        if (window.confirm('New version available! Reload to update?')) {
            registration.waiting.postMessage({ type: 'SKIP_WAITING' });
            window.location.reload();
        }
    }
});